import React, { useMemo, useState } from 'react'
import Lesson from './Lesson'
import Accordion from '../../../Components/Accordion/Accordion'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import ExpandLessIcon from '@material-ui/icons/ExpandLess'
import { pathOr, pipe } from 'ramda'

function Chapter({ state, chapter, index }) {
  const [isOpen, setIsOpen] = useState(false)

  const hasLessons = useMemo(
    () => pipe(pathOr(0, ['lessons', 'length']), Boolean)(chapter),
    [chapter],
  )

  return (
    <Accordion
      key={'chapter' + index}
      trigger={
        <>
          <h1>
            {chapter.title}{' '}
            {!hasLessons ? null : isOpen ? (
              <ExpandLessIcon />
            ) : (
              <ExpandMoreIcon />
            )}
          </h1>
          <p>{chapter.description}</p>
        </>
      }
      onChange={(newState) => setIsOpen(newState)}
      triggerDisabled={!hasLessons}
    >
      <div className='lessons'>
        {chapter.lessons.map((lesson, index) => (
          <Lesson
            key={'lesson' + index}
            lesson={lesson}
            index={index}
            userType={state.userType}
          />
        ))}
      </div>
    </Accordion>
  )
}

export default Chapter
